import { add, get, removeKey } from 'library/utilities/Storage';
import { ONBOARDING_STORAGE_VERSION, TOUR_IDS } from './constants';
var PENDING_TOUR_KEY = 'onboarding_pending_tour';
var welcomeKey = function (userId) {
    return "onboarding_".concat(ONBOARDING_STORAGE_VERSION, "_").concat(userId, "_welcome");
};
var tourKey = function (userId, tourId) {
    return "onboarding_".concat(ONBOARDING_STORAGE_VERSION, "_").concat(userId, "_").concat(tourId);
};
export var isWelcomeComplete = function (userId) {
    return get(welcomeKey(userId)) === 'done';
};
export var markWelcomeComplete = function (userId) {
    add(welcomeKey(userId), 'done');
};
export var isTourComplete = function (userId, tourId) {
    return get(tourKey(userId, tourId)) === 'done';
};
export var markTourComplete = function (userId, tourId) {
    add(tourKey(userId, tourId), 'done');
};
export var clearTourCompletion = function (userId, tourId) {
    removeKey(tourKey(userId, tourId));
};
export var clearAllOnboarding = function (userId) {
    removeKey(welcomeKey(userId));
    TOUR_IDS.forEach(function (tourId) { return removeKey(tourKey(userId, tourId)); });
};
export var setPendingTour = function (tourId) {
    window.sessionStorage.setItem(PENDING_TOUR_KEY, tourId);
};
export var consumePendingTour = function () {
    var tourId = window.sessionStorage.getItem(PENDING_TOUR_KEY);
    if (!tourId) {
        return null;
    }
    window.sessionStorage.removeItem(PENDING_TOUR_KEY);
    return tourId;
};
export var peekPendingTour = function () {
    return window.sessionStorage.getItem(PENDING_TOUR_KEY);
};
